"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Routes = void 0;
var Routes;
(function (Routes) {
    Routes["HOME"] = "home";
    Routes["QUESTION"] = "question";
    Routes["FORM"] = "form";
    Routes["RESULTS"] = "results";
})(Routes = exports.Routes || (exports.Routes = {}));
